import { render, staticRenderFns } from "./adminSet.vue?vue&type=template&id=76b08c58&scoped=true&"
import script from "./adminSet.vue?vue&type=script&lang=js&"
export * from "./adminSet.vue?vue&type=script&lang=js&"
import style0 from "./adminSet.vue?vue&type=style&index=0&id=76b08c58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b08c58",
  null
  
)

export default component.exports